import {isDefined} from "@/helper/Value";

export const OPEN_FAN_KEY = 'job-bot';

const store = {
	namespaced: true,
	state: {
		showQuestionnaire: false,
		job: undefined,
		postFinish: undefined,
		onContinueLater: undefined,
		onClose: undefined,
	},
	actions: {
		showQuestionnaire ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setJob', data.job);
			commit('setPostFinish', isDefined(data.postFinish) ? data.postFinish : false);
			commit('setOnContinueLater', data.onContinueLater);
			commit('setOnClose', data.onClose);

			commit('setShowQuestionnaire', true);
		},
		closeQuestionnaire ({commit, state}, data)
		{
			if (data?.continueLater && state.onContinueLater)
			{
				state.onContinueLater({
					job: state.job
				});
			}

			if (!data?.continueLater && state.onClose)
			{
				state.onClose({
					job: state.job
				});
			}

			commit('setShowQuestionnaire', false);

			commit('setJob', undefined);
			commit('setPostFinish', undefined);
			commit('setOnContinueLater', undefined);
			commit('setOnClose', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShowQuestionnaire: (state, value) => state.showQuestionnaire = value,
		setJob: (state, value) => state.job = value,
		setPostFinish: (state, value) => state.postFinish = value,
		setOnContinueLater: (state, value) => state.onContinueLater = value,
		setOnClose: (state, value) => state.onClose = value,
	},
};

export default store;
